import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Config } from '../.env.js';

const BankDropdown = ({ selectedBank, handleBankChange }) => {
    const [banks, setBanks] = useState([]);

    useEffect(() => {
        const fetchBanks = async () => {
            try {
                const response = await axios.get(`${Config.API_URL}/api/banks`);
                setBanks(response.data);
            } catch (error) {
                console.error("Error fetching banks:", error);
            }
        };
        fetchBanks();
    }, []);

    return (
        <div className="control" style={{ width: "353px", borderRadius: "4px", justifyContent: "center" }}>
            <div className="select is-fullwidth" style={{ width: "100%" }}>
                <select value={selectedBank} onChange={handleBankChange}>
                    <option value="">Select a Bank</option>
                    {banks.map((bank, index) => (
                        <option key={index} value={bank.name}>
                            {bank.name}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default BankDropdown;
